// extracted by mini-css-extract-plugin
export default {"label-col":"ClosedDatesRequest_label-col__3DeMT","closed-dates-table":"ClosedDatesRequest_closed-dates-table__vQl9U"};